import { useMemo } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import ReactMarkdown from "react-markdown";

export default function WideTile({ url, name, description, onClick }: any) {
  const randomImg = useMemo(() => {
    const idx = Math.floor(Math.random() * 14) + 1;
    const paddedIdx = idx.toString().padStart(2, "0");
    return `/tmp_img_${paddedIdx}.png`;
  }, []);
  const imgSrc = url || randomImg;
  const imgAlt = imgSrc.split("/").pop();

  return (
    <Card
      className="cursor-pointer hover:shadow-lg transition-shadow w-full sm:w-[95vw] md:w-[80vw] max-w-4xl mx-auto flex flex-col md:flex-row items-stretch p-0"
      onClick={onClick}
      style={{ aspectRatio: undefined }}
    >
      <div className="w-full md:w-1/3 aspect-[16/9] md:aspect-[1/1] bg-gray-100 overflow-hidden rounded-t-xl md:rounded-t-none md:rounded-l-xl flex-shrink-0">
        <img src={imgSrc} alt={imgAlt} className="w-full h-full object-cover" />
      </div>
      <div className="w-full md:w-3/5 flex flex-col justify-center p-6 text-left">
        <CardHeader className="p-0 text-left">
          <CardTitle className="text-xl mb-2 text-left">{name}</CardTitle>
          <CardDescription className="text-gray-600 text-left break-words line-clamp-4 overflow-hidden max-h-32">
            <ReactMarkdown className="prose max-w-none">
              {description}
            </ReactMarkdown>
          </CardDescription>
        </CardHeader>
      </div>
    </Card>
  );
}
